// @flow
import * as React from 'react';
import type { intlShape } from 'react-intl';
import { FormattedMessage } from 'react-intl';
import Head from 'next/head';
import GlobalCss from '../../../common/GlobalCss';
import messages from '../../messages';
import Footer from '../../../components/mobile/Footer';
import Suggestions from '../../../Suggestions/components/SuggestionsList/container';
import HeaderSerp from '../../../common/Header/HeaderSerp/container';
import GdprCookieBanner from '../../../Gdpr/components/mobile/GdprCookieBanner/container';
import styles from './styles';

type Props = {
  what: string,
  intl: intlShape,
};

function Error404({ what, intl }: Props): React.Node {
  return (
    <div>
      <Head>
        <title>{intl.formatMessage(messages.pageNotFound)}</title>
        <meta name="robots" content="noindex,nofollow,noarchive" />
        <meta name="googlebot" content="noindex,nofollow,noarchive" />
        <GlobalCss />
      </Head>
      <div className="main" data-test="noresults">
        <HeaderSerp currentSearch={what} />
        <GdprCookieBanner />

        <div className="notFoundMessage">
          <h1>
            <FormattedMessage {...messages.pageNotFound} />
          </h1>
          <h2>
            <FormattedMessage {...messages.pageNotFoundMsg} />
          </h2>

          <hr />
        </div>

        <Suggestions />
      </div>
      <Footer />
      <style jsx>{styles}</style>
    </div>
  );
}

export default Error404;



// WEBPACK FOOTER //
// ./app/Error/components/Error404/index.js